/**
 * The tenant that owns platform-wide shared content.
 *
 * Some libraries are deliberately NOT per-tenant: sales training videos and
 * custom documents are authored once and read by every tenant. They are stored
 * under a single owning tenant, historically Solerro's, because that predates
 * multi-tenancy.
 *
 * This module exists so that identity lives in exactly one place instead of
 * being pasted as a literal into feature code. Moving the shared library to a
 * different tenant is then a config change plus a data migration, not a search
 * and replace.
 *
 * NOTE: this is an owner id for shared content, not a fallback. Never use it to
 * stand in for "the current user's tenant" — that is what
 * `getCurrentTenantId()` is for, and substituting this value there writes one
 * tenant's records into another's.
 */

/** Solerro — the historical home of the shared content library. */
const DEFAULT_PLATFORM_CONTENT_TENANT_ID = "73ef7154-be00-4600-a4a6-34185ea3e6b4";

export const PLATFORM_CONTENT_TENANT_ID: string =
  import.meta.env.VITE_PLATFORM_CONTENT_TENANT_ID ||
  DEFAULT_PLATFORM_CONTENT_TENANT_ID;
